$("input[name=VAT]").change(showVatNumber);
$("input[name=VAT]").click(showVatNumber);
var __Error = false;
$().ready(function(){  
  try{
    if($("#txtNote").val().indexOf("----------------------------") > -1){
      $("#txtNote").val($("#txtNote").val().substring(0,$("#txtNote").val().indexOf("----------------------------")));
    }
  }catch(e){}
});

function showVatNumber(){
  $(".errorSelectVAT").hide();
  $(".errorEnterVAT").hide();
  if($("input[name=VAT]:checked").length){
    if($("input[name=VAT]:checked").val() == "Yes"){
      $(".divEnterVAT").show();
    }else{
      $(".divEnterVAT").hide();
      __Error = false;
    }
  }else{
    $(".errorSelectVAT").show();
    __Error = true;
  }       
}

$("form [type=submit]").click(function() {
  $("[type=submit]", $(this).parents("form")).removeAttr("clicked");
  $(this).attr("clicked", "true");
});

$("form#cartform").submit(function(e){
  if(e.type == "submit" && e.currentTarget.id == "cartform" && $("[type=submit][clicked=true]")[0].id == "checkout"){
    __Error = false;
    CheckUsageType();
    CheckSiteCompany();
    CheckContractor();
    CheckCountry();
    showVatNumber();
    CheckTerms();
    CheckVATNumber();
    if(!__Error){
      $("#note").val(
        $("#txtNote").val() + 
        String.fromCharCode(10) + "----------------------------" + 
        String.fromCharCode(10) + "Purpose: " + $("#selectUsageType option:selected").text() +
        String.fromCharCode(10) + "Site/Company: " + $("#txtSiteCompany").val() +
        String.fromCharCode(10) + "Contractor/Company: " + $("#txtContractor").val() +
        String.fromCharCode(10) + "Country: " + $("#selectCountry").val() +
        String.fromCharCode(10) + "VAT Registered: " + $("input[name=VAT]:checked").val() + 
        String.fromCharCode(10) + "VAT Number: " + $("#txtVATNumber").val()
      )
    }
    return !__Error;
  }
  return true;
});

function CheckUsageType(){
  if($("#selectUsageType").val() == ""){
    $(".errorUsageType").show();
    __Error = true;
  } else {
    $(".errorUsageType").hide();
  }
}

function CheckSiteCompany(){
  if($("#divSiteCompany").is(":visible")){
    if($("#txtSiteCompany").val().trim() == ""){
      $(".errorSiteCompany").show();
      __Error = true;
    } else {
      $(".errorSiteCompany").hide();
    }
  }
}

function CheckContractor(){
  if($("#divContractor").is(":visible")){
    if($("#txtContractor").val().trim() == ""){
      $(".errorContractor").show();
      __Error = true;
    } else {
      $(".errorContractor").hide();
    }
  }
}

function CheckCountry(){
  if($("#divCountry").is(":visible")){
    if($("#selectCountry").val() == ""){
      $(".errorCountry").show();
      __Error = true;
    } else {
      $(".errorCountry").hide();
    }
  }
}

function CheckVATNumber(){
  if($("input[name=VAT]:checked").val()=="Yes"){
    if($("#txtVATNumber").val().trim() == ""){
      $(".errorEnterVAT").show();
      __Error = true;
    } else {
      $(".errorEnterVAT").hide();
    }
  }
}

function CheckTerms(){
  if(!$("#chkTerms").is(":checked")){
    $(".errorTerms").show();
    __Error = true;
  } else {
    $(".errorTerms").hide();
  }
}